
export const BASE_URL = 'https://pureahrapigcp-prod.el.r.appspot.com/';
export const PROD_BASE_URL =
  'https://pureahrapigcp-prod.el.r.appspot.com/v1/api';

export const SIGNUPENDPOINT = 'v1/api/users/send-otp?login_type=mobile';
export const LOGINENDPOINT = 'v1/api/users/login-user?login_type=mobile';
export const REACT_APP_GOOGLE_API_KEY =
  'AIzaSyA4a5d0rlDLWKK66iKmIZoN_mUyCp7N2N8';
export const MEAL_ITEM_DISCARD_WARNING_TITLE = 'Discard existing cart item?';
export const MEAL_ITEM_DISCARD_WARNING_CONTENT =
  'Your cart already contains meal subscription. Do you want to discard the selection and add new meal subscription plan instead?';
export const USER_TYPES = {
  PRO_MEMBER: 'PRO_MEMBER',
  ALL: 'ALL',
};

export const ORDER_FAILED_TITLE = 'Sorry !';
export const ORDER_FAILED_CONTENT =
  'Your transaction has failed. Please go back and try again. In case the money has been debited from your account, it will be refunded to you within 5-7 working days.';

export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];

export const ROLE_OPTIONS =[
  { value: 'Acoustic Guitar', label: 'Acoustic Guitar' },
  { value: 'Piano', label: 'Piano' },
  { value: 'Electric Guitar', label: 'Electric Guitar' },
  { value: 'Violin', label: 'Violin' },
  { value: 'Electronic Keyboard', label: 'Electronic Keyboard' },
  { value: 'Ukulele', label: 'Ukulele' },
  { value: 'Flute', label: 'Flute' },
  { value: 'Tabla', label: 'Tabla' },
  { value: 'Indian Vocals', label: 'Indian Vocals' },
  { value: 'Bollywood Vocals', label: 'Bollywood Vocals' },
  { value: 'Bharatanatyam', label: 'Bharatanatyam' },
  { value: 'Kathak', label: 'Kathak' },
  { value: 'Western Vocals', label: 'Western Vocals' },
  { value: 'Carnatic Vocals', label: 'Carnatic Vocals' },
  { value: 'Bollywood Dance', label: 'Bollywood Dance' },
  { value: 'Malayalam Music', label: 'Malayalam Music' },
  { value: 'Kannada Music', label: 'Kannada Music' },
  { value: 'Telugu Music', label: 'Telugu Music' },
  { value: 'Tamil Music', label: 'Tamil Music' }
];

export const HOME_SETUP_OPTIONS = ['Yes', 'No, but I can arrange'];

export const YEAR_OF_EXP_OPTIONS = ['0-5 Years', '6-10 Years', '10+ Years'];

export const TUTOR_QUALIFICATION_OPTIONS = ['Diploma', 'B.A', 'MA', 'PHD', 'Others'];

export const ENGLISH_PROFICIENCY_OPTIONS = ['No English Proficiency', 'Basic', 'Intermediate', 'Fluent'];

export const MUSIC_CERTIFICATION_OPTIONS = ['Rockschool', 'Trinity', 'LCME', 'ABRSM', 'Others'];

export const locale = 'en'; // Default to English
export const direction = 'ltr'; // Default to left-to-right

export const PORTION_SIZE = {
  REGULAR: 'Regular',
  JUMBO: 'Jumbo',
};
export const DEFAULT_ORDER_DATA = {
  "_id": "67066d966415e48056d7ca60",
  "orderId": "OD1728474517788_1",
  "userId": "C30432_2",
  "cartItems": [
    {
      "qty": 1,
      "__typename": "regular-food",
      "restaurantItemId": {
        "_id": "6705a3ee0ed65f2e96830dee",
        "restaurantId": {
          "_id": "65e56e2beb683e6a9d6cb88e",
          "restaurantName": "Instruments",
          "outlets": [
            "65e56e92eb683e6a9d6cb8a7",
            "65e592b3a9d489d0829b9618"
          ],
          "createdAt": "2024-03-04T06:46:03.674Z",
          "updatedAt": "2024-03-04T09:21:55.688Z",
          "__v": 2,
          "description": "Master your favorite instrument with personalized one-on-one online live lessons. Learn guitar, piano, violin, and more, guided by expert instructors from the comfort of your home.",
          "images": [
            "https://storage.googleapis.com/pureaahar-file-storage-dev/cuisines/images/20686a5d-7176-4aef-b870-265fe0cca1c4.jpeg",
            "https://storage.googleapis.com/pureaahar-file-storage-dev/cuisines/images/5276e510-15ed-4bc4-8689-04253c112273.png"
          ],
          "bg": "https://storage.googleapis.com/pureaahar-file-storage-dev/banners/images/adb475bf-e3bd-44a8-ba0c-81b2a3913010.webp",
          "logo": "https://storage.googleapis.com/pureaahar-file-storage-dev/cuisines/images/02b9b1f5-77fb-462a-b618-9c3b544c2eb7.png"
        },
        "outletId": {
          "_id": "65e56e92eb683e6a9d6cb8a7",
          "restaurantId": "65e56e2beb683e6a9d6cb88e",
          "outletLocation": {
            "latitude": 22.5768143,
            "longitude": 88.4323592,
            "distance": 5
          },
          "outletAddress": "SECTOR V, DN Block, Sector V, Bidhannagar, Kolkata, West Bengal, India",
          "isOpened": true,
          "acceptingOrder": true,
          "timing": {
            "fromTime": "09:00",
            "toTime": "11:00"
          },
          "rating": "",
          "ratingCount": null,
          "certifications": [],
          "menuSections": [
            {
              "category": "6705798eb34b5bc21bf0f1cc",
              "position": 1,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e96830dee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830def",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830df9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dfa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dfb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dfc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dfd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dfe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830dff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e00",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e01",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e02",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e03",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e04",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e05",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e06",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e07",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e08",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e09",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e0f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e10",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e11",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e12",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e13",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e14",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e15",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e16",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e17",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e18",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e19",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e1f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e20",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e21",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e22",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e23",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e24",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e25",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e26",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e27",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e28",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e29",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e2f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e30",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e31",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e32",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e33",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e34",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e35",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e36",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e37",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e38",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e39",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e3f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e40",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e41",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e42",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e43",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e44",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e45",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e46",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e47",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e48",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e49",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e4f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e50",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e51",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e52",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e53",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e54",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e55",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e56",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e57",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e58",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e59",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e5f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e60",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e61",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e62",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e63",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e64",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e65",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e66",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e67",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e68",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e69",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e6f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e70",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e71",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e72",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e73",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e74",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e75",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e76",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e77",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e78",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e79",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e7f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e80",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e81",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e82",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e83",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e84",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e85",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e86",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e87",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e88",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e89",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e8f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e90",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e91",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e92",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e93",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e94",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e95",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e96",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e97",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e98",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e99",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e9a",
                  "position": 1
                }
              ],
              "_id": "6705798eb34b5bc21bf0f1ce"
            },
            {
              "category": "670579a2b34b5bc21bf0f206",
              "position": 2,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e96830e9b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e9c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e9d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e9e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830e9f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ea9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eaa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eab",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eac",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ead",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eae",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eaf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eb9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eba",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ebb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ebc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ebd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ebe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ebf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ec9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eca",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ecb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ecc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ecd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ece",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ecf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ed9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eda",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830edb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830edc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830edd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ede",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830edf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ee9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eea",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eeb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eec",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eed",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eef",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ef9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830efa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830efb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830efc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830efd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830efe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830eff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f00",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f01",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f02",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f03",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f04",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f05",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f06",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f07",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f08",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f09",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f0f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f10",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f11",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f12",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f13",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f14",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f15",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f16",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f17",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f18",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f19",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f1f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f20",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f21",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f22",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f23",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f24",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f25",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f26",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f27",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f28",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f29",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f2f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f30",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f31",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f32",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f33",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f34",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f35",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f36",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f37",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f38",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f39",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f3f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f40",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f41",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f42",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f43",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f44",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f45",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f46",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f47",
                  "position": 1
                }
              ],
              "_id": "670579a2b34b5bc21bf0f208"
            },
            {
              "category": "670579afb34b5bc21bf0f253",
              "position": 3,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e96830f48",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f49",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f4f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f50",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f51",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f52",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f53",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f54",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f55",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f56",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f57",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f58",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f59",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f5f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f60",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f61",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f62",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f63",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f64",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f65",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f66",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f67",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f68",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f69",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f6f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f70",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f71",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f72",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f73",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f74",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f75",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f76",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f77",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f78",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f79",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f7f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f80",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f81",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f82",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f83",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f84",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f85",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f86",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f87",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f88",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f89",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f8f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f90",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f91",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f92",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f93",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f94",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f95",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f96",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f97",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f98",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f99",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830f9f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fa9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830faa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fab",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fac",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fad",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fae",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830faf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fb9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fba",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fbb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fbc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fbd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fbe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fbf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fc9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fca",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fcb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fcc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fcd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fce",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fcf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fd9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fda",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fdb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fdc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fdd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fde",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fdf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fe9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fea",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830feb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fec",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fed",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fef",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff4",
                  "position": 1
                }
              ],
              "_id": "670579afb34b5bc21bf0f255"
            },
            {
              "category": "670579bab34b5bc21bf0f2ad",
              "position": 4,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e96830ff5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ff9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ffa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ffb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ffc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ffd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830ffe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96830fff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831000",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831001",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831002",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831003",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831004",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831005",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831006",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831007",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831008",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831009",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683100f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831010",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831011",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831012",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831013",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831014",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831015",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831016",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831017",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831018",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831019",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683101f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831020",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831021",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831022",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831023",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831024",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831025",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831026",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831027",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831028",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831029",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683102f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831030",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831031",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831032",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831033",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831034",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831035",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831036",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831037",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831038",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831039",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683103f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831040",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831041",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831042",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831043",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831044",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831045",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831046",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831047",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831048",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831049",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683104f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831050",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831051",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831052",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831053",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831054",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831055",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831056",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831057",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831058",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831059",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683105f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831060",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831061",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831062",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831063",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831064",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831065",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831066",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831067",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831068",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831069",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683106f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831070",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831071",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831072",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831073",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831074",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831075",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831076",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831077",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831078",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831079",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683107f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831080",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831081",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831082",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831083",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831084",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831085",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831086",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831087",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831088",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831089",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683108f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831090",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831091",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831092",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831093",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831094",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831095",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831096",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831097",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831098",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831099",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683109f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a1",
                  "position": 1
                }
              ],
              "_id": "670579bab34b5bc21bf0f2af"
            },
            {
              "category": "670579c5b34b5bc21bf0f30e",
              "position": 5,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e968310a2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310a9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310aa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ab",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ac",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ad",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ae",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310af",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310b9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ba",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310bb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310bc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310bd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310be",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310bf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310c9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ca",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310cb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310cc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310cd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ce",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310cf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310d9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310da",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310db",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310dc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310dd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310de",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310df",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310e9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ea",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310eb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ec",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ed",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ef",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310f9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310fa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310fb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310fc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310fd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310fe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968310ff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831100",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831101",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831102",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831103",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831104",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831105",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831106",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831107",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831108",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831109",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683110f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831110",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831111",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831112",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831113",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831114",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831115",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831116",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831117",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831118",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831119",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683111f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831120",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831121",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831122",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831123",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831124",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831125",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831126",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831127",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831128",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831129",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683112f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831130",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831131",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831132",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831133",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831134",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831135",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831136",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831137",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831138",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831139",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683113f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831140",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831141",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831142",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831143",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831144",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831145",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831146",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831147",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831148",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831149",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683114a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683114b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683114c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683114d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683114e",
                  "position": 1
                }
              ],
              "_id": "670579c5b34b5bc21bf0f310"
            },
            {
              "category": "670579ebb34b5bc21bf0f37c",
              "position": 6,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e9683114f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831150",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831151",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831152",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831153",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831154",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831155",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831156",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831157",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831158",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831159",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683115f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831160",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831161",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831162",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831163",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831164",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831165",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831166",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831167",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831168",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831169",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683116f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831170",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831171",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831172",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831173",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831174",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831175",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831176",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831177",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831178",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831179",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683117f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831180",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831181",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831182",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831183",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831184",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831185",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831186",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831187",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831188",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831189",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683118f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831190",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831191",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831192",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831193",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831194",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831195",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831196",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831197",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831198",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831199",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683119f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311a9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311aa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ab",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ac",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ad",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ae",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311af",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311b9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ba",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311bb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311bc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311bd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311be",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311bf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311c9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ca",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311cb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311cc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311cd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ce",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311cf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311d9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311da",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311db",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311dc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311dd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311de",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311df",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311e9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ea",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311eb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ec",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ed",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ef",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311f9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311fa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311fb",
                  "position": 1
                }
              ],
              "_id": "670579ebb34b5bc21bf0f37e"
            },
            {
              "category": "670579f5b34b5bc21bf0f400",
              "position": 7,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e968311fc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311fd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311fe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968311ff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831200",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831201",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831202",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831203",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831204",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831205",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831206",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831207",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831208",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831209",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683120f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831210",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831211",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831212",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831213",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831214",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831215",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831216",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831217",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831218",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831219",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683121f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831220",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831221",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831222",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831223",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831224",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831225",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831226",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831227",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831228",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831229",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683122f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831230",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831231",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831232",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831233",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831234",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831235",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831236",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831237",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831238",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831239",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683123f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831240",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831241",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831242",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831243",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831244",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831245",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831246",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831247",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831248",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831249",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683124f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831250",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831251",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831252",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831253",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831254",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831255",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831256",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831257",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831258",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831259",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683125f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831260",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831261",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831262",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831263",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831264",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831265",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831266",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831267",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831268",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831269",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683126f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831270",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831271",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831272",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831273",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831274",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831275",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831276",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831277",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831278",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831279",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683127f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831280",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831281",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831282",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831283",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831284",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831285",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831286",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831287",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831288",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831289",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683128f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831290",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831291",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831292",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831293",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831294",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831295",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831296",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831297",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831298",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831299",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683129f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312a8",
                  "position": 1
                }
              ],
              "_id": "670579f5b34b5bc21bf0f402"
            },
            {
              "category": "67057a00b34b5bc21bf0f491",
              "position": 8,
              "items": [
                {
                  "itemId": "6705a3ee0ed65f2e968312a9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312aa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ab",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ac",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ad",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ae",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312af",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312b9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ba",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312bb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312bc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312bd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312be",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312bf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312c9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ca",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312cb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312cc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312cd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ce",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312cf",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312d9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312da",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312db",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312dc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312dd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312de",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312df",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312e9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ea",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312eb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ec",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ed",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ee",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ef",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f0",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f1",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f2",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f3",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f4",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f5",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f6",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f7",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f8",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312f9",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312fa",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312fb",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312fc",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312fd",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312fe",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e968312ff",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831300",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831301",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831302",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831303",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831304",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831305",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831306",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831307",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831308",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831309",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683130f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831310",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831311",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831312",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831313",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831314",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831315",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831316",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831317",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831318",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831319",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683131f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831320",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831321",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831322",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831323",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831324",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831325",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831326",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831327",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831328",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831329",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683132f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831330",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831331",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831332",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831333",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831334",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831335",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831336",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831337",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831338",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831339",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683133f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831340",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831341",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831342",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831343",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831344",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831345",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831346",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831347",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831348",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831349",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134a",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134b",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134c",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134d",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134e",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e9683134f",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831350",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831351",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831352",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831353",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831354",
                  "position": 1
                },
                {
                  "itemId": "6705a3ee0ed65f2e96831355",
                  "position": 1
                }
              ],
              "_id": "67057a00b34b5bc21bf0f493"
            }
          ],
          "__v": 9
        },
        "categoryId": "6705798eb34b5bc21bf0f1cc",
        "skills": [
          "Acoustic Guitar"
        ],
        "itemName": "Acoustic-Guitar Foundation",
        "itemDescription": "Enroll in our foundation Acoustic-Guitar course with a 3 Months package. Perfect for those looking to develop a strong foundation and enhance their skills over 3 months.",
        "status ": "available",
        "tags": [
          "Foundation"
        ],
        "isInStock": true,
        "courseDuration": "3 Months",
        "sessionCount": 24,
        "sessionDuration": "30 m",
        "pricing": [
          {
            "price": 8640,
            "discountPercent": 0,
            "currency": "INR",
            "isActive": true,
            "_id": "67061ea0bbc906be8830dffb"
          }
        ],
        "countryCode": "IN",
        "cuisines": [],
        "options": {
          "_id": "67061ea0bbc906be8830dffc",
          "choices": [],
          "addons": []
        },
        "status": "available",
        "isVeg": true
      },
      "_id": "67066d906415e48056d7c415",
      "itemId": "05ec8a55-6709-4b32-8f6c-8d08a0b32f64"
    }
  ],
  "mealPlans": [],
  "transactionId": "order_P6vcRXUlF6pVwz",
  "totalBaseFee": 8640,
  "finalBasePrice": 8640,
  "additionalCharges": {
    "taxPercent": 0
  },
  "invoiceId": "INV1728474517788_1",
  "orderDate": "2024-10-09T11:48:37.788Z",
  "orderType": "regular",
  "deliveryAddress": {
    "contactDetails": {
      "type": "mobile",
      "countryCode": "91",
      "contactNo": "7978684715",
      "std": ""
    },
    "_id": "6703a8588c97e0c2e3688449",
    "userId": "C30432_2",
    "addressId": "ADDR1728292952566",
    "addressType": "Home",
    "spocName": "",
    "addressLine1": "Flat 15, ",
    "addressLine2": "Purbi Appt",
    "addressLine3": "Mahisbatan",
    "landmark": "",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700091",
    "country": "India",
    "status": "default",
    "number": "7978684715",
    "createdAt": "2024-10-07T09:22:32.571Z",
    "updatedAt": "2024-10-07T09:22:32.571Z",
    "__v": 0
  },
  "status": "CONFIRMED",
  "spInstructions": "",
  "paymentType": "online",
  "orderDeliveryTime": "Now",
  "feedbackStatus": "PENDING",
  "reviews": [],
  "userTimeSlots": [],
  "sessionSlots": [],
  "createdAt": "2024-10-09T11:48:38.583Z",
  "updatedAt": "2024-10-09T12:18:16.161Z",
  "__v": 0,
  "driveLink": "asdasdasd",
  "meetingLink": "asdasdasd",
  "userDetails": [
    {
      "_id": "67037b40ef1a32c0a77f923e",
      "userId": "C30432_2",
      "emailId": "jayjeetchamp@gmail.com",
      "loginOtp": [],
      "referralCode": "PA_0CCD83E7B",
      "status": "11",
      "isProMember": false,
      "role": "admin",
      "rewardCoins": 0,
      "referalList": [],
      "codStrikes": 0,
      "redeemedOffers": [
        {
          "offerId": "670659fc4d9c753312637517",
          "redeemedCount": 1,
          "_id": "67065d934d9c753312638e08"
        }
      ],
      "createdAt": "2024-10-07T06:10:08.622Z",
      "updatedAt": "2024-10-09T10:40:19.843Z",
      "__v": 0,
      "cartId": "CART1728281425174",
      "password": "$2b$10$VJxRD7VNGC3kpXNj/iQoJ.6YrYc6gP9lyF8pstBI/73uDOLhMPYFS",
      "birthDate": null,
      "isReceiveWAUpdates": true,
      "gender": "male",
      "fullName": "Jayjeet",
      "phone": "917978684715"
    }
  ],
  "offerDetails": [],
  "reviewDetails": []
}
export const NO_OFFERS_FOUND = 'No Offers found.';
